import { Stack } from "@mantine/core";
import { PageHeader } from "@xplatform/design-system";
import { IconPuzzle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { usePermissionCatalogue } from "@hooks/access/queries";
import { useAdminPermissions } from "@hooks/useAdminPermissions";
import { EnvironmentBanner, ModulesCard } from "@features/Access";

/**
 * Access > Modules: the application's BeeHive modules, the same list the permission catalogue
 * groups permissions by. A new service starts here: create its module, then add the module's
 * permissions (Access > Permissions) and grant it provider credentials (Providers).
 */
export const ModulesPage = () => {
  const { t } = useTranslation();
  const { canManagePermissionCatalogue } = useAdminPermissions();
  const catalogue = usePermissionCatalogue();

  return (
    <Stack gap="md">
      <PageHeader
        title={t("admin.access.modules.title")}
        description={t("admin.access.modules.pageDescription")}
        icon={<IconPuzzle size={28} />}
      />
      <EnvironmentBanner />
      <ModulesCard
        modules={catalogue.data?.modules ?? null}
        error={catalogue.error}
        canManage={canManagePermissionCatalogue}
        onCreated={catalogue.reload}
      />
    </Stack>
  );
};
